import { render, staticRenderFns } from "./CourseCardLearningTopics.vue?vue&type=template&id=29b5a3ce&scoped=true"
import script from "./CourseCardLearningTopics.vue?vue&type=script&lang=js"
export * from "./CourseCardLearningTopics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b5a3ce",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ListIcon: require('/builds/marketing/abstracta.academy-website/components/ListIcon.vue').default})
